export default "__VITE_ASSET__CL7_cF4a__"